var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"1em","width":"1em","viewBox":"0 0 48 48","fill":"currentColor"}},[_c('path',{attrs:{"fill":"currentColor","d":"m24 30-10-9.95h20Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }